import { ClipLoader } from "react-spinners";
import React from "react";

interface Props {
  size?: number;
  color?: string;
  theme?: "light" | "dark";
}

export const Loader = ({ size = 20, color, theme = "dark" }: Props) => {
  const resolvedColor = color ?? (theme === "light" ? "#000" : "#fff");

  return (
    <ClipLoader
      color={resolvedColor}
      cssOverride={{
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      size={size}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
};
